import React from 'react';
import { Paper } from '@mui/material';
import makeStyles from '@mui/styles/makeStyles';
import ButtonWithFontAwesome from '@monorepo/shared/src/components/common/Buttons/ButtonWithFontAwesome';
import { translate } from '@monorepo/shared/node_modules/@lwtears/lwt-common-frontend/lib/@common/util/i18n-util';
import useTeachingOrder from 'state/hooks/use-teaching-order';

const t = (key, options?) => translate('teachingOrder', key, options);

const EditTeachingOrderFooter: React.FC = () => {
  const classes = useStyles();

  const [
    { hasUnsavedChanges, isActiveTeachingOrderDisplayed, isSaving },
    { handleSave, confirmSettingTeachingOrder, handleExiting },
  ] = useTeachingOrder();
  const buttonText = hasUnsavedChanges ? t('saveChanges') : t('useThisOrder');
  const buttonAction = hasUnsavedChanges ? handleSave : confirmSettingTeachingOrder;

  return (
    <Paper className={classes.container}>
      <ButtonWithFontAwesome
        className={classes.button}
        onClick={handleExiting}
        text={t('cancelEditing')}
        aria-label={t('cancelEditing')}
        variant="outlined"
        color="primary"
        disabled={!hasUnsavedChanges || isSaving}
      />
      <ButtonWithFontAwesome
        className={classes.button}
        onClick={buttonAction}
        text={buttonText}
        aria-label={buttonText}
        variant="contained"
        color="primary"
        disabled={(isActiveTeachingOrderDisplayed && !hasUnsavedChanges) || isSaving}
      />
    </Paper>
  );
};

const useStyles = makeStyles(() => ({
  container: {
    display: 'flex',
    justifyContent: 'space-between',
    position: 'sticky',
    bottom: 0,
    height: 60,
  },
  button: {
    margin: '10px 30px',
  },
}));
export default EditTeachingOrderFooter;
